import axios from 'axios';
import RequestInterceptor from '../interceptors/request-interceptor';
import ResponseInterceptor from '../interceptors/response-interceptor';

RequestInterceptor(axios.interceptors);
ResponseInterceptor(axios.interceptors);

class Builder {
  config = {
    baseURL: '',
    params: {},
    headers: {},
    data: new FormData(),
  };

  constructor(baseUrl) {
    this.config.baseURL = baseUrl;
  }

  setMethod(method) {
    this.config.method = method;
    return this;
  }

  setData(data) {
    this.config.data = data;
    return this;
  }

  setBaseUrl(baseUrl) {
    this.config.baseURL = baseUrl;
    return this;
  }

  setUrl(url) {
    this.config.url = url;
    return this;
  }

  setParam(key, value) {
    this.config.params[key] = value;
    return this;
  }

  setHeader(key, value) {
    this.config.headers[key] = value;
    return this;
  }

  set(key, value) {
    this.config.data.append(key, value);
    return this;
  }

  setFile(key, file) {
    this.config.data.append(key, file);
    return this;
  }

  build(noCache = false) {
    const auth = localStorage.getObject('auth');
    if (auth) {
      this.setHeader('Authorization', `Bearer ${auth.accessToken}`);
    }
    if (noCache) {
      this.setHeader('Cache-Control', 'no-cache');
    }
    return axios(this.config);
  }
}

export default function () {
  return new Builder(process.env.API_ENDPOINT);
}



// WEBPACK FOOTER //
// ./src/services/builders/base.js